import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PropsWithChildren } from 'library/types';

const HomeFooterColumnContainer = ({
	children,
	header,
}: {
	header: string;
} & PropsWithChildren): React.JSX.Element => {
	return (
		<Box
			sx={{
				width: 'auto',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-start',
				alignContent: 'flex-start',
			}}>
			<Typography variant="body2">{header}</Typography>
			{children}
		</Box>
	);
};

export default HomeFooterColumnContainer;
